// @ts-nocheck
import noop from 'lodash/noop';

import { endall } from './endall-transition';

export const notifyChartRenderComplete = (
  chart,
  requestHash,
  alsoRun = noop
) => {
  chart
    .transition()
    .duration(0)
    .call(endall, () => {
      alsoRun();
    });
};
